query GET_FAQS {
  faqs {
    items {
      createdDatetime
      link
      linkText
      question
      answer
      displayOrder
    }
  }
}
